import { Button, Flex } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { TemplatesTable } from "../../components/Admin/Tables/Templates";
import TemplateForm from "../../components/Form/Template";
import ModalWrapper from "../../components/generic/modal";
import { usePermissions } from "../../hooks/permissions";

export const Templates = () => {

  const [addTemplate, setAddTemplate] = useState<boolean>(false);
  const { selectedAccount } = useSelector((state: RootState) => state.admin);
  const { hasPermission2 } = usePermissions();
  const canCreateTemplates = hasPermission2("sms.templates.create", "own");


  return (
  <div style={{ padding: "20px", width: "100%" }}>
      <Flex justify="right" align="right" style={{ padding: "10px" }}>
        {canCreateTemplates && (
          <Flex gap={10}>
            <Button
              type="primary"
              onClick={() => {
                setAddTemplate(true);
              }}
            >
              Add Template
            </Button>
          </Flex>
        )}
      </Flex>

      <div style={{ marginTop: "20px" }}>
        {addTemplate && (
          <ModalWrapper isModalOpen={addTemplate} setIsModalOpen={setAddTemplate} title="Add Template">
            <TemplateForm setIsModalOpen={setAddTemplate} account_id={selectedAccount} editData={null} />
          </ModalWrapper>
        )}
        <TemplatesTable searchInput="" />
      </div>
    </div>
  );
};
